module.exports = __webpack_public_path__ + "img/g10.420ff76d.jpg";